<template>
  <b-card
    border-variant="primary" header-bg-variant="primary" header-text-variant="white"
    header-class="p-3 font-size-lg font-weight-bold"
    header="Money Movements"
  >
    <table class="table table-sm table-bordered mb-0">
      <thead>
        <th width="55%" class="text-center">Movement</th>
        <th width="45%" class="text-center">Amount</th>
      </thead>
      <tr>
        <td class="align-middle">
          <b-badge variant="primary">Client Receivable</b-badge>
        </td>
        <td class="text-right font-weight-bold">{{ money.clientReceivable | currency }}</td>
      </tr>
      <tr>
        <td class="align-middle">
          <b-badge variant="secondary">Total Income (DKG AR network)</b-badge>
        </td>
        <td class="text-right">{{ money.totalIncome | currency }}</td>
      </tr>
      <tr v-for="(ar, index) in arSplit" :key="index">
        <td class="align-middle pl-10 text-muted">{{ ar.repId }} {{ ar.role }} Payable</td>
        <td class="text-right">{{ arPayable(ar) | currency }}</td>
      </tr>
      <tr>
        <td class="align-middle font-weight-bolder" style="background-color: lightgray">
          <b-badge variant="primary">Insurer Payable (net)</b-badge>
        </td>
        <td class="text-right font-weight-bolder" style="background-color: lightgray">
          {{ money.insurerPayable | currency }}
        </td>
      </tr>
    </table>
  </b-card>
</template>

<script>
export default {
  name: "MoneyMovements",

  props: {
    money: {
      type: Object,
      required: true
    },
    arSplit: {
      type: Array,
      required: true
    }
  },

  methods: {
    arPayable: function(ar) {
      const value =
        Number(ar.commission || 0) +
        Number(ar.gst || 0) +
        Number(ar.fee || 0) +
        Number(ar.feeGst || 0);
      return Math.round((value + Number.EPSILON) * 100) / 100;
    }
  }
};
</script>
